import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'

import { fetchMembersStatuses } from 'state/actions/CMT/ClanManagement'

class UpdateMembersStatusesManager extends React.Component {
    static updateTimeout = 30 * 1000

    static propTypes = {
        isError: PropTypes.bool.isRequired,
        isFetching: PropTypes.bool.isRequired,
        membersCount: PropTypes.number.isRequired,
        updateMembersAt: PropTypes.instanceOf(Date),

        fetchMembersStatuses:  PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.currentDebounceWait = null
        this.updateMembersStatuses = this.updateMembersStatuses.bind(this)
        this.updateMembersStatusesDebounce = this.createUpdateMembersStatusesDebounce()
    }

    componentDidMount() {
        this.updateMembersStatusesDebounce()
    }

    componentWillUnmount() {
        this.updateMembersStatusesDebounce.cancel()
    }

    createUpdateMembersStatusesDebounce(wait) {
        wait = wait || UpdateMembersStatusesManager.updateTimeout
        if (this.currentDebounceWait === wait && this.updateMembersStatusesDebounce) {
            return this.updateMembersStatusesDebounce
        }

        this.currentDebounceWait = wait
        return debounce(
            this.updateMembersStatuses,
            wait,
        )
    }

    updateMembersStatuses() {
        if (!this.props.updateMembersAt) return

        const now = new Date()
        const timeFromLastUpdate = now.getTime() - this.props.updateMembersAt.getTime()
        const wait = UpdateMembersStatusesManager.updateTimeout - timeFromLastUpdate
        this.updateMembersStatusesDebounce = this.createUpdateMembersStatusesDebounce(wait > 0 ? wait : void 0)

        if (wait > 0 ||
            this.props.isFetching ||
            this.props.isError ||
            this.props.membersCount === 0) {
            this.updateMembersStatusesDebounce()
            return
        }

        this.props.fetchMembersStatuses()
            .then(this.updateMembersStatusesDebounce)
            .catch(this.updateMembersStatusesDebounce)
    }

    render() {
        return null
    }
}

const mapStateToProps = (state) => ({
    isError: state.clanManagement.isError,
    isFetching: state.clanManagement.fetchingCounter > 0 || state.fetching.counter > 0,
    membersCount: state.members.members.length,
    updateMembersAt: state.members.updateMembersAt,
})

const mapDispatchToProps = {
    fetchMembersStatuses,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateMembersStatusesManager)



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/UpdateMembersStatusesManager/index.js